import React from 'react';

import { Controller } from 'react-hook-form';
import { Calendar } from 'primereact/calendar';
import moment from 'moment-timezone';

import InputErrorMessage from 'components/UI/InputErrorMessage/InputErrorMessage';
import LabelName from 'components/UI/LabelName/LabelName';
import { useUserDetailsContext } from 'context/userDetailsContext';

function CourtEventDate({ control, trigger, errors, setValue }) {
  const { userDetails } = useUserDetailsContext();
  const timezone = userDetails?.timezone || moment.tz.guess();

  // Get current moment in user's timezone
  const nowInUserTz = moment().tz(timezone);

  // Create minDate - a Date object representing today in user's timezone
  // We use the year, month, day from the user's timezone to create the Date
  const minDate = new Date(nowInUserTz.year(), nowInUserTz.month(), nowInUserTz.date(), 0, 0, 0, 0);

  /**
   * When user selects a date, set default start and end times.
   * - If today (in user's timezone): use current time rounded to next half hour
   * - If other date: default to 12:00 AM - 12:30 AM
   */
  function changeTimeValues(selectedDate) {
    if (!selectedDate) return;

    // Get fresh current time in user's timezone
    const currentInUserTz = moment().tz(timezone);

    // Check if selected date is today in user's timezone
    const isToday =
      selectedDate.getDate() === currentInUserTz.date() &&
      selectedDate.getMonth() === currentInUserTz.month() &&
      selectedDate.getFullYear() === currentInUserTz.year();

    let startHour = 0;
    let startMinute = 0;

    if (isToday) {
      // Use current time in user's timezone, rounded to next half hour
      startHour = currentInUserTz.hour();
      startMinute = currentInUserTz.minute();

      // Round to next half hour
      if (startMinute !== 0 && startMinute !== 30) {
        startMinute = startMinute + 30 - (startMinute % 30);
        if (startMinute >= 60) {
          startMinute = 0;
          startHour += 1;
        }
      }
    }

    // Create start time using the selected date with calculated hours/minutes
    const startTime = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), startHour, startMinute, 0, 0);

    // End time is 30 minutes after start time
    const endTime = new Date(startTime.getTime() + 30 * 60 * 1000);

    setValue('meeting_start_time', startTime);
    setValue('meeting_end_time', endTime);
  }

  return (
    <div className="d-flex align-items-center py-2 flex-wrap">
      <div className="col-md-4 col-12">
        <LabelName required={true} htmlFor="when">
          When
        </LabelName>
      </div>
      <div className="col-md-8 col-12">
        <Controller
          name="when"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <Calendar
              id={field.name}
              value={field.value || null}
              onChange={(e) => {
                field.onChange(e.value);
                changeTimeValues(e.value);
                trigger('when');
              }}
              minDate={minDate}
              placeholder="Date"
              monthNavigator
              yearNavigator
              yearRange={`${new Date().getFullYear() - 100}:${new Date().getFullYear() + 50}`}
              className="input-shadow w-100"
              inputRef={field.ref}
            />
          )}
        />
      </div>
      <div className="offset-md-4">
        {errors?.when?.type === 'required' ? <InputErrorMessage>Please select event date</InputErrorMessage> : ''}
      </div>
    </div>
  );
}

export default CourtEventDate;
